<template>
	<div>
		<section class="content-header">
			<div class="container-fluid">
				<div class="row">
					<div class="col-md-6">
						<h4>{{ $t('label.setting') }}</h4>
					</div>
					<div class="col-md-6">
						<ol class="breadcrumb float-sm-right">
							<li class="breadcrumb-item">
								<router-link to="/">{{ $t("label.home")}}</router-link>
							</li>
							<li class="breadcrumb-item">{{ $t("label.setting")}}</li>
							<li class="breadcrumb-item active">{{ $t("label.vehicle_type")}}</li>
						</ol>
					</div>
				</div>
			</div>
		</section>

		<div class="content">
			<div class="container-fluid">
				<div class="row">
					<div class="col-md-12">
						<div class="card card-success card-outline">
							<div class="card-header">
								<div class="row">
									<div class="col-md-6 col-6">
										<h3 class="card-title mt-1">{{ $t("label.vehicle_type")}}</h3>
									</div>
									<div class="col-md-6 col-6 text-right">
										<button type="button" class="btn btn-sm btn-primary" @click="addType" v-if="this.$hasPermission('tempvehicle.vehicle_type.create')">
											<fa :icon="fas.faPlus" /> {{ $t('label.create') }}
										</button>
									</div>
								</div>
							</div>
							<div class="card-body">
								<div class="row">
									<div class="form-group col-md-4 col-8">
										<div class="input-group">
											<input type="text" class="form-control" autofocus v-model="search" :placeholder="$t('label.search')">
											<div class="input-group-append">
												<span class="input-group-text">
													<fa :icon="fas.faSearch"/>
												</span>
											</div>
										</div>
									</div>
								</div>
								<div class="table-responsive" v-if="filteredTypes.length > 0">
									<table class="table table-bordered mb-0">
										<tbody>
											<tr>
												<th nowrap style="width: 1%;"></th>
												<th>{{ $t('label.type') }}</th>
												<th>{{ $t('label.created_at') }}</th>
												<th>{{ $t('label.updated_at') }}</th>
												<th>{{ $t('label.deleted_at') }}</th>
												<th></th>
											</tr>
											<tr v-for="(item, index) in filteredTypes" :key="index">
												<td>{{ index + 1}}</td>
												<td>{{ item.name }}</td>
												<td>{{ item.created_at }}</td>
												<td>{{ item.updated_at }}</td>
												<td>{{ item.deleted_at }}</td>
												<td nowrap style="width: 1%;">
													<a href="javascript: void(0)" @click="editType(item.id,item.name)" class="mr-2" :title="$t('label.edit')" v-if="$hasPermission('tempvehicle.vehicle_type.edit')">
														<fa :icon="fas.faEdit" style="color: green;"/>
													</a>
													<template v-if="item.deleted_at">
														<a href="javascript: void(0)" @click="restoreType(item.id)" :title="$t('label.restore')" v-if="$hasPermission('tempvehicle.vehicle_type.create')">
															<fa :icon="fas.faUndo"/>
														</a>
													</template>
													<template v-else>
														<a href="javascript: void(0)" @click="deleteType(item.id)" :title="$t('label.delete')" v-if="$hasPermission('tempvehicle.vehicle_type.delete')">
															<fa :icon="fas.faTrash" style="color: red;"/>
														</a>
													</template>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
								<div class="callout callout-success" v-else>
									<label>{{$t('label.no_data')}}</label>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="modal fade" id="vehicleTypeModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 v-if="!type.id" class="modal-title" id="vehicleTypeTitle">{{ $t('label.create') }}</h5>
						<h5 v-else class="modal-title" id="vehicleTypeTitle">{{ $t('label.edit') }}</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="alert alert-danger" v-if="type.errors.length > 0">
							<p class="mb-0"><strong>Whoops!</strong> Something went wrong!</p>
							<ul>
								<li v-for="(error, index) in type.errors" :key="index">
									{{ error }}
								</li>
							</ul>
						</div>
						<div class="form-group row mb-0">
							<label class="col-md-4 col-form-label">{{ $t('label.type') }} <span style="color:red" :title="$t('label.asterisk')"> *</span></label>
							<div class="col-md-8">
								<input v-model="type.name" type="text" name="vehicle_type" v-validate="'required'" class="form-control">
								<span v-if="errors.has('vehicle_type')" class="text-danger">{{ errors.first('vehicle_type')}}</span>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal">{{ $t('label.close') }}</button>
						<button v-if="!type.id" @click="store" type="button" class="btn btn-primary">{{ $t('label.save') }}</button>
						<button v-else @click="update" type="button" class="btn btn-primary">{{ $t('label.save') }}</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { fas } from "@fortawesome/free-solid-svg-icons";
	export default {
		name: "VehicleTypes",
		computed: {
			fas() {
				return fas;
			},
			filteredTypes(){
				return this.types.filter(type => {
					let search = this.search.toLowerCase();
					return type.name.toLowerCase().includes(search);
				});
			}
		},
		mounted () {
			this.getVehicleTypes();
		},
		data() {
			return {
				baseURI: "",
				types: [],
				type: {
					id: '',
					name: '',
					created_at: '',
					updated_at: '',
					errors: []
				},
				search: ''
			};
		},
		methods: {
			validate() {
				this.$validator.validateAll();
				return this.errors.any();
			},
			getVehicleTypes(){
				this.$store.state.loading.status = true;
                let url = this.baseURI + 'vehicle-types';
                GDCE_Client.requestApi("GET", url).then(response => {
					this.types = response.data;
					this.$store.state.loading.status = false;
				}).catch(error => {
                    this.$store.state.loading.status = false;
				});
			},
			store(e){
				this.$validator.validate().then(result => {
					if (!result) {
						e.preventDefault();
					}else{
						this.$store.state.loading.status = true;
						let url = this.baseURI + 'vehicle-types';
						this.type.errors = [];
						GDCE_Client.requestApi("POST", url, this.type).then(response => {
							this.$store.state.loading.status = false;
							$('#vehicleTypeModal').modal('hide');
							this.getVehicleTypes();
						}).catch(error => {
							this.$store.state.loading.status = false;
							if (typeof error.data === 'object') {
								this.type.errors = _.flatten(_.toArray(error.data.errors));
							} else {
								this.type.errors = ['Something went wrong. Please try again.'];
							}
						});
					}
				})
			},
			update(e){
				this.$validator.validate().then(result => {
					if (!result) {
						e.preventDefault();
					}else{
						let url = this.baseURI + 'vehicle-types/'+ this.type.id;
						this.type.errors = [];
						GDCE_Client.requestApi("PATCH", url, this.type).then(response => {
							$('#vehicleTypeModal').modal('hide');
							this.getVehicleTypes();
						}).catch(error => {
							this.$store.state.loading.status = false;
							if (typeof error.data === 'object') {
								this.type.errors = _.flatten(_.toArray(error.data.errors));
							} else {
								this.type.errors = ['Something went wrong. Please try again.'];
							}
						});
					}
				})
			},
			addType() {
				this.$validator.reset();
				this.type.name = "";
				$("#vehicleTypeModal").modal("show");
			},
			editType(id,name) {
				this.type.id = id;
				this.type.name = name;
				this.$validator.reset();
				$("#vehicleTypeModal").modal("show");
			},
			deleteType(id) {
				this.$swal({
					title: this.$t('label.confirm'),
					text: this.$t('label.confirm_delete'),
					icon: "warning",
					buttons: true,
					dangerMode: true
				}).then(willDelete => {
					if (willDelete) {
						let url = this.baseURI + "/vehicle-types/" + id;
						GDCE_Client.requestApi("DELETE", url).then(response => {
							this.getVehicleTypes();
						}).catch(()=>{});
					}
				});
			},
			restoreType(id) {
				let url = this.baseURI + "/vehicle-types/" + id + '/restore';
				GDCE_Client.requestApi("POST", url).then(response => {
					this.getVehicleTypes();
				}).catch(()=>{});
			}
		}
	};
</script>
